import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import queryString from "query-string";

import {
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
} from "../auth/AuthActions";

import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/react";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: rgb(0, 43, 54);
`;

class Activate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      auth: RESOLVE_LOCAL_AUTH_STATE(),
      user: RESOLVE_LOCAL_USER_STATE(),
      activation_msg: "",
      redirect_status: false,
      loading: true,
    };
  }

  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    const { api_activation_link } = parsed;

    if (!api_activation_link) {
      this.setState({
        activation_msg: "Invalid activation link.",
        redirect_status: false,
        loading: false,
      });
      return;
    }

    const secure_api_activation_link = api_activation_link.replace("http:", "https:");

    axios
      .get(secure_api_activation_link)
      .then((res) => {
        let redirect_status = res.status === 200;
        this.setState({
          activation_msg: res.data,
          redirect_status: redirect_status,
          loading: false,
        });
      })
      .catch((err) => {
        console.error('Account Activation Error:', err);
        console.error('Account Activation Error Response:', err.response);
        console.error('Account Activation Error Status:', err.response?.status);
        console.error('Account Activation Error Data:', err.response?.data);
        
        let errorMessage = "Activation failed.";
        if (err.response?.status === 404) {
          errorMessage = "Activation link not found or expired.";
        } else if (err.response?.status === 400) {
          errorMessage = "Invalid activation link.";
        } else if (err.response?.status === 500) {
          errorMessage = "Server error occurred during activation. Please try again later.";
        }
        
        this.setState({
          activation_msg: errorMessage,
          redirect_status: false,
          loading: false,
        });
      });
  }

  render() {
    const { loading, redirect_status, activation_msg } = this.state;

    return (
      <div className="container signup-custom">
        <h1>Activating account...</h1>
        <div className="sweet-loading">
          <ClipLoader css={override} size={150} color={"#123abc"} loading={loading} />
        </div>

        {!loading && redirect_status && (
          <div>
            <p>{activation_msg}</p>
            <Link to="/accounts/signin">Click here to continue.</Link>
          </div>
        )}

        {!loading && !redirect_status && (
          <div>
            <p>{activation_msg}</p>
          </div>
        )}
      </div>
    );
  }
}

export default Activate;
